// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import type { BUS_TYPE } from '../../../types/buses';
import RouteCard from '../../RouteCard';
import StopCard from '../../StopCard';
import * as routesActions from '../../../actions/routes';
import * as mapActions from '../../../actions/map';
import * as selectors from '../../../reducers';

import mapViewStyles from '../MapView/mapView.css';
import Popup from '../../Popup';
import RouteStopEditPopupContainer from '../../RouteStopEditPopupContainer';


type RoutePropTypes = {
  routeId: number,
  currentRoute: number,
  fetchRouteStarted: Function,
  clearCurrentRoute: Function,
  setMapPosition: Function,
  setCurrentRoute: Function,
  bus: BUS_TYPE,
};

type RouteStateTypes = {
  // seeingStops?: boolean,
  positionSet: boolean,
};

class RouteView extends Component<RoutePropTypes, RouteStateTypes> {
  constructor(props) {
    super(props);
    this.state = {
      positionSet: false,
      // seeingStops: false,
    };
  }

  componentWillMount() {
    const {
      setMapPosition,
      routeId,
      fetchRouteStarted,
      currentRoute,
      setCurrentRoute,
      bus,
    } = this.props;

    fetchRouteStarted(routeId);
    if (!currentRoute || currentRoute === -1) {
      setCurrentRoute(routeId);
    }

  }

  componentWillReceiveProps(nextProps: RoutePropTypes) {
    const { setMapPosition, bus, currentRoute, fetchRouteStarted } = this.props;
    const { positionSet } = this.state
    if (nextProps.currentRoute !== currentRoute){
      fetchRouteStarted(nextProps.currentRoute);
      // if (bus && bus.location){
      //   setMapPosition(14, bus.location.longitude, bus.location.latitude, true);
      // }
    }
  }

  componentWillUnmount() {
    const { clearCurrentRoute, currentRoute = -1 } = this.props;
    clearCurrentRoute(currentRoute);
  }

  render() {
    const { currentRoute } = this.props;
    return (
      <Fragment>
        <div className={mapViewStyles.cardContainer}>
          <RouteCard id={currentRoute} />
        </div>
        <StopCard />

      </Fragment>
    );
  }
}

export default connect(
  (state, ownProps) => {
    const routeId = parseInt(ownProps.match.params.id, 10);
    const currentRoute = selectors.getSelectedRoute(state);
    const routeObj = selectors.getRoute(state, currentRoute);
    let bus;
    if (routeObj) {
      bus = selectors.getBus(state, routeObj.bus);
    }
    return {
      routeId,
      currentRoute,
      bus,
    };
  },
  dispatch => ({
    fetchRouteStarted(id) {
      dispatch(routesActions.fetchRouteStarted(id));
    },
    clearCurrentRoute(id) {
      dispatch(routesActions.clearCurrentRoute());
      dispatch(routesActions.hideStopsDetail(id));
    },
    setCurrentRoute(id: number) {
      dispatch(routesActions.setCurrentRoute(id));
    },
    setMapPosition(
      zoom: number,
      longitude: number,
      latitude: number,
      animate: boolean,
    ) {
      dispatch(mapActions.setMapPosition(
        zoom,
        longitude,
        latitude,
        animate,
        // { longitude: -0.5, latitude: 0.50 },
      ));
    },
  }),
)(withRouter(RouteView));



// WEBPACK FOOTER //
// ./src/scripts/components/views/MapRouteView/index.jsx